module.exports = "<div class=\"relative\">\n  <video width=\"290\" height=\"165\" controlslist=\"nodownload\" controls class=\"video\">\n      <source src=\"{{selectedData}}\" type=\"video/mp4\">\n      <source src=\"{{selectedData}}\" type=\"video/ogg\">\n      Your browser does not support the video tag.\n      </video>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/application/core-module/scora-common-module/scora-video-view/scora-video-view.component.html
// module id = 1020
// module chunks = 6